// extracted by mini-css-extract-plugin
export default {"content":"ComingSoonContent_content__7C+Ip","content__info":"ComingSoonContent_content__info__9-frc"};